export default "__VITE_PUBLIC_ASSET__146771b5__"